import * as Yup from 'yup';

import type { ICustomerLeadSalesTaxInfoTabFormValues } from 'src/components/customers/CustomerLeadTypes';
import { filePayloadArrayValidationSchema } from 'src/components/validation/FilePayloadArrayValidationSchema';
import { fileReferencesToFilePayloads } from 'src/helpers';
import type { ICustomerLeadProduct } from 'src/types/customers/ICustomerLeadProduct';

export const customerLeadSalesTaxInfoValidationSchema = Yup.object<ICustomerLeadSalesTaxInfoTabFormValues>().shape({
  salesTaxFiles: filePayloadArrayValidationSchema.min(0),
});

export const customerLeadSalesTaxInfoInitialValues = (
  customerProductLead: ICustomerLeadProduct
): ICustomerLeadSalesTaxInfoTabFormValues => ({
  exempt: customerProductLead.exempt,
  salesTaxFiles: fileReferencesToFilePayloads(customerProductLead.salesTaxFiles),
});
